import { MehOutlined, SmileOutlined, SunOutlined } from "@ant-design/icons";

enum AITon {
  friendly = "friendly",
  neutral = "neutral",
  elevated = "elevated",
}

export const aiTonAsString = (
  sampleMessageCategory: AITon
): string => {
  switch (sampleMessageCategory) {
    case AITon.friendly:
      return "Amical";
    case AITon.neutral:
      return "Neutre";
    case AITon.elevated:
      return "Soutenu";
    default:
      return "";
  }
};

export const renderTonOption = (aiTon: AITon): React.ReactNode => {
  switch (aiTon) {
    case AITon.friendly:
      return <>
        <SunOutlined style={{ marginRight: 6 }} />
        {aiTonAsString(aiTon)}
      </>
    case AITon.neutral:
      return <>
        <MehOutlined style={{ marginRight: 6 }} />
        {aiTonAsString(aiTon)}
      </>
    case AITon.elevated:
      return <>
        <SmileOutlined style={{ marginRight: 6 }} />
        {aiTonAsString(aiTon)}
      </>
    default:
      return aiTonAsString(aiTon);
  }
};

export default AITon;
